import PropTypes from 'prop-types';

import styles from './PartnerInfo.scss';

export const DefaultPartnerInfo = ({
  isChecked = false,
  partnerTitle,
  defaultPartnerText = null,
}) => (
  <div className={`${styles.DefaultPartnerInfo} ${isChecked ? styles.checked : ''}`}>
    <p>{defaultPartnerText || `I don't mind which ${partnerTitle} I use`}</p>
  </div>
);

DefaultPartnerInfo.propTypes = {
  isChecked: PropTypes.bool,
  partnerTitle: PropTypes.string.isRequired,
  defaultPartnerText: PropTypes.string,
};
